// import FeatureSection from "../../components/feature_section/FeatureSection";
import CategoriesSlider from "../../components/categories/CategoriesSlider";
import BestSellingSlider from "../../components/best_selling/BestSellingSlider";
import HeroTrendingProductSlider from "../../components/hero_trending_product_slider/HeroTrendingProductSlider";
import Testimonials from "../../components/testimonials/Testimonials";
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getLanguage } from '../../utils/Helper';
// import {
//   Sparkles, Lamp, Heart, Wind, HomeIcon, Star, UtensilsCrossed
// } from 'lucide-react';
import "./Home.scss";
import ShopByColorCategory from "../../components/shop_by_color_category/ShopByColorCategory";
// import FlashDeals from "../../components/flash_deals/FlashDeals";
import SaleProducts from "../../components/sale_products/SaleProducts";
import RecentlyViewed from "../../components/recently_viewed/RecentlyViewed";
import EpicSlider from "../../components/epic_slider/EpicSlider";
// import HomeSlider from "../../components/home_slider/HomeSlider";


// ═══════════════════════════════════════════════════════════════
// SCROLL-REVEAL HOOK
// ═══════════════════════════════════════════════════════════════
function useReveal(options = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setVisible(true);
          obs.unobserve(el);
        }
      },
      {
        threshold: options.threshold ?? 0.05,
        rootMargin: options.rootMargin ?? '200px 0px -100px 0px',
      }
    );

    obs.observe(el);
    return () => obs.disconnect();
  });

  return [ref, visible];
}


// ═══════════════════════════════════════════════════════════════
// SUBCATEGORY CONFIG
// ═══════════════════════════════════════════════════════════════
// const SUB_CAT_CONFIG = {
//   'Decorative':                { icon: Sparkles,         gradient: 'linear-gradient(135deg, #F5A623, #D4AF37)', nameAr: 'زينة رمضانية' },
//   'Lanterns & Lighting':       { icon: Lamp,             gradient: 'linear-gradient(135deg, #FF8C00, #FFD700)', nameAr: 'فوانيس وإضاءة' },
//   'Prayer Essentials':         { icon: Heart,            gradient: 'linear-gradient(135deg, #14B8A6, #059669)', nameAr: 'مستلزمات الصلاة' },
//   'Incense & Bakhoor':         { icon: Wind,             gradient: 'linear-gradient(135deg, #8B5CF6, #6366F1)', nameAr: 'بخور والعطور' },
//   'Ramadan Home Decor':        { icon: HomeIcon,         gradient: 'linear-gradient(135deg, #F43F5E, #EC4899)', nameAr: 'ديكور منزلي رمضاني' },
//   'Kids Ramadan Accessories':  { icon: Star,             gradient: 'linear-gradient(135deg, #06B6D4, #38BDF8)', nameAr: 'إكسسوارات أطفال رمضان' },
//   'Iftar Accessories':         { icon: UtensilsCrossed,  gradient: 'linear-gradient(135deg, #F59E0B, #FB923C)', nameAr: 'أدوات الإفطار' },
// };


// ═══════════════════════════════════════════════════════════════
// HERO - Enhanced with Video Loading & Performance
// ═══════════════════════════════════════════════════════════════
// const Hero = () => {
//   const [videoLoaded, setVideoLoaded] = useState(false);
//   const videoRef = useRef(null);
//   const lang= getLanguage();

//   return (
//     <section className="hero" id="home">
//       {/* Poster - visible until video loads */}
//       <div 
//         className="hero__poster"
//         style={{ 
//           backgroundImage: 'url(/assets/hero-poster.jpg)',
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           position: 'absolute',
//           inset: 0,
//           opacity: videoLoaded ? 0 : 1,
//           transition: 'opacity 0.8s ease',
//           zIndex: 1,
//         }}
//       />
      
//       {/* Video */}
//       <video 
//         ref={videoRef}
//         className="hero__video" 
//         autoPlay 
//         muted 
//         loop 
//         playsInline 
//         preload="metadata"
//         poster="/assets/hero-poster.jpg"
//         onLoadedData={() => setVideoLoaded(true)}
//         style={{ 
//           opacity: videoLoaded ? 1 : 0, 
//           transition: 'opacity 0.8s ease',
//           zIndex: 0,
//         }}
//       >
//         <source src="/assets/new-banner-video-optimized.webm" type="video/webm" auto/>
//         <source src="/assets/new-banner-video-optimized.mp4" type="video/mp4" />
//       </video>

      

//       <div className="hero__overlay" />
//       <div className="hero__content">
//         <h1 className="hero__title">ADDMIX STORE</h1>
//         <p className="hero__subtitle">الفخامة التي تستحقها &bull; Luxury You Deserve</p>
//         <button 
//           className="hero__cta" 
//           onClick={() => document.querySelector('#collections')?.scrollIntoView({ behavior: 'smooth' })}
//         >
//           {lang === "EN"? "Discover Our Collections": "اكتشف المجموعات"}
//         </button>
//       </div>
//     </section>
//   );
// };

// ═══════════════════════════════════════════════════════════════
// COLLECTIONS SLIDER - Auto-playing Carousel with Touch Support
// ═══════════════════════════════════════════════════════════════
const Collections = ({ collections }) => {
  const navigate = useNavigate();
  const lang = getLanguage();
  const [sectionRef, sectionVisible] = useReveal();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const sliderRef = useRef(null);
  const autoPlayRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);


  // Auto-play functionality
  useEffect(() => {
    if (!isHovered && sectionVisible) {
      autoPlayRef.current = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % collections.length);
      }, 4000); // Change slide every 4 seconds
    }

    return () => {
      if (autoPlayRef.current) {
        clearInterval(autoPlayRef.current);
      }
    };
  }, [isHovered, collections.length, sectionVisible]);

  if (!collections || collections.length === 0) return null;

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + collections.length) % collections.length);
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % collections.length);
  };

  // Touch handlers for mobile swipe
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const swipeThreshold = 50;
    const diff = touchStartX.current - touchEndX.current;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        goToNext();
      } else {
        goToPrev();
      }
    }
  };

  // Calculate which cards to show (show 3 cards at a time on desktop, 1 on mobile)
  const getVisibleCards = () => {
    // const isMobile = window.innerWidth <= 768;
    const cardsToShow = 3;
    const cards = [];
    
    for (let i = 0; i < cardsToShow; i++) {
      const index = (currentIndex + i) % collections.length;
      cards.push(collections[index]);
    }
    return cards;
  };

  const visibleCards = getVisibleCards();

  return (
    <section 
      className="collections" 
      id="collections" 
      ref={sectionRef}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <h2 className="section-title">
        {lang === 'EN' ? 'Our Featured Collections' : 'مجموعاتنا المميزة'}
      </h2>
      <p className="section-subtitle">
        {lang === 'EN' ? 'Discover a world of elegance and luxury' : 'اكتشف عالم من الأناقة والفخامة'}
      </p>

      <div className="collections__slider-container">
        {/* Navigation Arrows */}
        <button 
          className="collections__nav collections__nav--prev" 
          onClick={goToPrev}
          aria-label="Previous"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M15 18l-6-6 6-6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <button 
          className="collections__nav collections__nav--next" 
          onClick={goToNext}
          aria-label="Next"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M9 18l6-6-6-6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {/* Slider Track */}
        <div 
          className="collections__slider-track"
          ref={sliderRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {visibleCards.map((collection, idx) => (
            <div
              key={`${collection.id}-${currentIndex}-${idx}`}
              className={`collection-card ${sectionVisible ? 'collection-card--visible' : ''}`}
              style={{ 
                animationDelay: sectionVisible ? `${idx * 0.1}s` : '0s'
              }}
              onClick={() => navigate(`/collection/${collection.name_url.toLowerCase().trim().split(' ').join('-')}`)}
            >
              <img src={collection.image_url} alt={collection.name} className="collection-card__img" />
              <div className="collection-card__overlay" />
              <div className="collection-card__info">
                <h3 className="collection-card__name">{collection.name}</h3>
                {collection.categories?.[0]?.name && (
                  <p className="collection-card__desc">{collection.categories[0].name}</p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Dots Indicator */}
        <div className="collections__dots">
          {collections.map((_, idx) => (
            <button
              key={idx}
              className={`collections__dot ${idx === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(idx)}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};


// ═══════════════════════════════════════════════════════════════
// RAMADAN — Enhanced with Image Preloading Fix
// ═══════════════════════════════════════════════════════════════
// const Ramadan = ({ ramadanCollection }) => {
//   const [sectionRef, sectionVisible] = useReveal();
//   const navigate = useNavigate();
//   const lang = getLanguage();
//   const [bgImageLoaded, setBgImageLoaded] = useState(false);

//   const subCategories = useMemo(() => {
//     const allSubs = [];
//     (ramadanCollection?.categories || []).forEach((cat) => {
//       (cat?.sub_categories || []).forEach((sub) => {
//         allSubs.push({ ...sub, parentCategory: cat });
//       });
//     });
//     return allSubs;
//   }, [ramadanCollection]);

//   // ✅ Preload background image للتأكد إنها بتحمل صح
//   useEffect(() => {
//     const bgImage = new Image();
//     bgImage.src = 'https://d9jmgltxulw4z.cloudfront.net/collections/1/1766683680737_79eda23c.webp';
    
//     bgImage.onload = () => {
//       setBgImageLoaded(true);
//       console.log('✅ Ramadan background image loaded successfully');
//     };
    
//     bgImage.onerror = () => {
//       console.warn('⚠️ Ramadan background image failed to load');
//       setBgImageLoaded(true); // Still show section with fallback color
//     };
//   }, []);

//   if (!ramadanCollection) return null;

//   return (
//     <section 
//       className={`ramadan ${bgImageLoaded ? 'bg-loaded' : 'bg-loading'}`} 
//       ref={sectionRef}
//     >
//       {/* Decorative stars floating */}
//       <div className="ramadan__stars">
//         {[...Array(12)].map((_, i) => (
//           <Star
//             key={i}
//             className="ramadan__star"
//             size={Math.random() * 16 + 8}
//             style={{
//               left: `${Math.random() * 100}%`,
//               top: `${Math.random() * 100}%`,
//               animationDelay: `${Math.random() * 3}s`,
//               opacity: Math.random() * 0.4 + 0.2,
//             }}
//           />
//         ))}
//       </div>

//       <div className={`ramadan__grid ${sectionVisible ? 'ramadan__grid--visible' : ''}`}>
//         {/* Left — text */}
//         <div className="ramadan__content">
//           <div className="ramadan__title-wrapper">
//             <h2 className="ramadan__title">
//               {lang === 'EN' ? 'Ramadan Special Collection' : 'مجموعة رمضان الخاصة'}
//             </h2>
//             <div className="ramadan__title-decoration">
//               <span>☪</span>
//               <div className="ramadan__title-line" />
//               <span>✦</span>
//             </div>
//           </div>

//           <p className="ramadan__desc">
//             {lang === 'EN'
//               ? 'Welcome the blessed month with the finest decorations and accessories. Elegant metallic lanterns, spiritual lighting, and décor pieces that add warmth and beauty to your home.'
//               : 'استقبل الشهر الفضيل بأجمل الزينة والديكورات الرمضانية الفاخرة. فوانيس معدنية أنيقة، إضاءة روحانية، وقطع ديكور تضيف لمسة من الجمال والدفء لمنزلك.'}
//           </p>

//           <button
//             className="hero__cta ramadan__cta"
//             onClick={() => navigate(`/collection/${ramadanCollection.name_url.toLowerCase().trim().split(' ').join('-')}`)}
//           >
//             {lang === 'EN' ? 'Shop Ramadan Collection' : 'تسوق مجموعة رمضان'}
//           </button>
//         </div>

//         {/* Right — subcategories grid */}
//         <div className="ramadan__subcategories">
//           {subCategories.map((sub, index) => {
//             const config = SUB_CAT_CONFIG[sub.name_url] || {
//               icon: Sparkles,
//               gradient: 'linear-gradient(135deg, #F5A623, #D4AF37)',
//               nameAr: sub.name,
//             };
//             const Icon = config.icon;

//             return (
//               <div
//                 key={sub.id}
//                 className={`ramadan__sub-card ${sectionVisible ? 'ramadan__sub-card--visible' : ''}`}
//                 style={{ animationDelay: sectionVisible ? `${0.2 + index * 0.08}s` : '0s' }}
//                 onClick={() => {
//                   const collectionUrl = ramadanCollection.name_url.toLowerCase().trim().split(' ').join('-');
//                   const catUrl = sub.parentCategory.name_url.toLowerCase().trim().split(' ').join('-');
//                   navigate(`/collection/${collectionUrl}/${catUrl}?sub_cat=${sub.name_url.toLowerCase().trim().split(' ').join('-')}`);
//                 }}
//               >
//                 <div className="ramadan__sub-glow" style={{ background: config.gradient }} />
//                 <div className="ramadan__sub-icon" style={{ background: config.gradient }}>
//                   <Icon size={32} color="#fff" strokeWidth={1.8} />
//                 </div>
//                 <p className="ramadan__sub-name">
//                   {lang === 'EN' ? sub.name : config.nameAr}
//                 </p>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// };


// ═══════════════════════════════════════════════════════════════
// BRANDS — Infinite Scroll 2 Rows
// ═══════════════════════════════════════════════════════════════
// const Brands = ({ brands }) => {
//   const [sectionRef, sectionVisible] = useReveal();
//   const lang = getLanguage();

//   if (!brands || brands.length === 0) return null;

//   const brandsExtended = [...brands];

//   // Split into 2 rows
//   const half = Math.ceil(brandsExtended.length / 2);
//   const row1 = brandsExtended.slice(0, half);
//   const row2 = brandsExtended.slice(half);

//   return (
//     <section className="brands" id="brands" ref={sectionRef} style={{ backgroundImage: "url('/assets/yellow background.jpg')" }}>
//       <h2 className="section-title section-title--white">
//         {lang === 'EN' ? 'Top Brands' : 'علامات تجارية عالمية'}
//       </h2>

//       <div className={`brands__container ${sectionVisible ? 'brands__container--visible' : ''}`}>
//         {/* Row 1 — scroll left */}
//         <div className="brands__row brands__row--left">
//           <div className="brands__track">
//             {row1.map((brand, i) => (
//               <div className="brands__card" key={`${brand.id}-${i}`}>
//                 <img src={brand.image_url} alt={brand.name} />
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Row 2 — scroll right */}
//         <div className="brands__row brands__row--right">
//           <div className="brands__track">
//             {row2.map((brand, i) => (
//               <div className="brands__card" key={`${brand.id}-${i}`}>
//                 <img src={brand.image_url} alt={brand.name} />
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };


// ═══════════════════════════════════════════════════════════════
// HOME
// ═══════════════════════════════════════════════════════════════
const Home = () => {
  const authContext = useAuth();
  const systemCollections = authContext?.systemCollections || [];

  // const ramadanCollection = useMemo(() => {
  //   return systemCollections.find(
  //     (c) => c.id === 1 || c.name_url?.toLowerCase().includes('ramadan')
  //   ) || null;
  // }, [systemCollections]);

  // All brands (no limit)
  // const allBrands = useMemo(() => {
  //   const brandMap = new Map();
  //   systemCollections.forEach((collection) => {
  //     (collection.top_brands || []).forEach((brand) => {
  //       if (!brandMap.has(brand.id)) {
  //         brandMap.set(brand.id, brand);
  //       }
  //     });
  //   });
  //   return Array.from(brandMap.values());
  // }, [systemCollections]);
  const epicSlides = [
    {
      // src: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80',
      // If screen is mo
      src: window.innerWidth > 600? '/assets/home-slider-men-1.png' : '/assets/home-slider-men-1-mobile.png',
      alt: 'Men Collection',
      label: 'Men',
      title: 'Discover Our Men\'s Collection',
      subtitle: 'Timeless style and modern elegance for the discerning gentleman.',
    },
    {
      src: window.innerWidth > 600? '/assets/home-slider-women-1.png' : '/assets/home-slider-women-1-mobile.png',
      alt: 'Women Collection',
      label: 'Women',
      title: 'Discover Our Women\'s Collection',
      subtitle: 'Elegant and contemporary styles for the modern woman.',
    },
  ];

  return (
    <div className="home-page">
      <section className="main-content container-fluid homepage">
        {/* <Hero /> */}
        {/* <HomeSlider/> */}
        <EpicSlider slides={epicSlides}/>
        {/* {ramadanCollection && <Ramadan ramadanCollection={ramadanCollection} />} */}
        <CategoriesSlider />
        <HeroTrendingProductSlider />
        <ShopByColorCategory />
        {systemCollections.length > 0 && (
          <Collections collections={systemCollections} />
        )}
        <BestSellingSlider />
        <SaleProducts pageSize={8} />
        {/* <FlashDeals limit={7}/> */}
        <Testimonials />
        {/* <FeatureSection /> */}
        {/* {allBrands.length > 0 && (
          <Brands brands={allBrands} />
        )} */}
        <RecentlyViewed />
      </section>
    </div>
  );
};

export default Home;